;(function($) {

  $(document).ready(function() {


    $('input.datepicker.date-in').datepicker({
      numberOfMonths: 2,
      firstDay: 1,
      minDate: 0,
      dateFormat: 'dd/mm/yy',
      onSelect: function() {
        var day = $(this).datepicker('getDate');
        next = Utils.getNextDay(day);
        $dateOut = $(this).closest('.js-datepicker-wrapper').find('.datepicker.date-out');
        $dateOut.datepicker('setDate', next);
        setTimeout(function(){
          $dateOut.datepicker('show');
        },200);

      }
    });

    $('input.datepicker:not(.date-in)').datepicker({
      numberOfMonths: 2,
      firstDay: 1,
      minDate: 0,
      dateFormat: 'dd/mm/yy',
    });


  });


})(jQuery)
